// Client-side presentation modes over the leaderboard-series payload. The
// server always returns official competitor ranks, with the ensemble and
// contracted (fixed-payment) forecasters flagged and score-sorted in place,
// never shifting competitor ranks. `withReferenceRanked` re-ranks the full
// field so references occupy rank slots (the Overview tab's default look);
// `competitorsOnly` drops them and keeps the official server ranks.

const isReference = (r) => Boolean(r.is_ensemble || r.is_fixed_payment);

export const competitorsOnly = (payload) => {
  if (!payload?.buckets) return payload;
  return {
    ...payload,
    buckets: payload.buckets.map((b) => ({
      ...b,
      rows: (b.rows || []).filter((r) => !isReference(r)),
    })),
  };
};

export const withReferenceRanked = (payload) => {
  if (!payload?.buckets) return payload;
  return {
    ...payload,
    buckets: payload.buckets.map((b) => {
      const rows = [...(b.rows || [])].sort((x, y) => x.avg_score - y.avg_score);
      // Dense rank (ties share a rank, no gaps), mirroring the server's
      // competitor ranking but over the full displayed field.
      let rank = 0;
      let prev = null;
      return {
        ...b,
        rows: rows.map((r) => {
          if (prev === null || r.avg_score !== prev) {
            rank += 1;
            prev = r.avg_score;
          }
          return { ...r, rank };
        }),
      };
    }),
  };
};
